import React, { useState } from "react";
import { Modal, Button, Input, notification, Spin } from "antd";
import {
   XIcon,
   Asterisk,
   UserProtectionSuccess,
   UserProtectionError
} from "../../../../assets/icons";
import * as Yup from "yup";
import { Formik } from "formik";
import AuthService from "../../../../base/services/authentication.service";
import { httpService } from "../../../../base/services/httpService.service";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./filters.scss";
import { useTranslation } from "../../../../i18n/LanguageContext";

const RepresentativeDetailsModal = ({
   visible,
   onCancel,
   onOk,
   id,
   fetchData,
   updateOrganization
}) => {
   const { t } = useTranslation();
   const formData = {
      name: "",
      location: "",
      phone: "",
      email: ""
   };
   const organizationId = AuthService.getUser()?.organizationId;
   const [loading, setLoading] = useState(false);

   const validationSchema = Yup.object({
      name: Yup.string().required(t("name-required-validation")),
      phone: Yup.string()
         .nullable()
         .test("is-valid-phone-number", t("invalid-phone-number-validation"), (value) => {
            if (!value) return false;
            return value.startsWith("+") && value.length > 7;
         })
         .required(t("phone-number-required-validation")),
      email: Yup.string()
         .email(t("invalid-email-validation"))
         .required(t("email-required-validation"))
   });

   const customNotificationSucess = (
      <div className="custom-notification-container">
         <div className="custom-notification-image-container">
            <img src={UserProtectionSuccess} alt="UserProtectionSuccess" />
         </div>
         <div className="custom-notification-text-container">
            <h3>{t("representative-added-success-title")}</h3>
            <p>{t("representative-added-success-description")}</p>
         </div>
      </div>
   );
   const customNotificationError = (
      <div className="custom-notification-container-error">
         <div className="custom-notification-image-container">
            <img src={UserProtectionError} alt="UserProtectionError" />
         </div>
         <div className="custom-notification-text-container-error">
            <h3>{t("toast-oops-title")}</h3>
            <p>{t("representative-add-error-description")}</p>
         </div>
      </div>
   );

   const openNotificationSuccess = () => {
      notification.open({
         description: customNotificationSucess,
         placement: "top"
      });
   };

   const openNotificationError = () => {
      notification.open({
         description: customNotificationError,
         placement: "top"
      });
   };

   const handleSubmit = async (values) => {
      setLoading(true);
      try {
         const response = await httpService.post(
            `/Organizations/${organizationId}/representative`,
            {
               name: values.name,
               location: values.location,
               phone: values.phone,
               email: values.email
            }
         );
         const responseData = response.data;
         const newId = responseData.data.id;
         onOk(newId);
         fetchData(newId, id);
         httpService.get(`/Organizations/${id}`, (res) => {
            updateOrganization(res.data);
         });
         openNotificationSuccess();
         setLoading(false);
      } catch (error) {
         openNotificationError();
         setLoading(false);
      }
   };

   return (
      <Modal
         open={visible}
         onCancel={onCancel}
         onOk={handleSubmit}
         closable={false}
         footer={[]}
         destroyOnClose
      >
         <Formik
            initialValues={formData}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
         >
            {({ errors, touched, values, handleSubmit, handleChange, setFieldValue }) => (
               <form onSubmit={handleSubmit}>
                  <div>
                     <img
                        src={XIcon}
                        alt="XIcon"
                        onClick={onCancel}
                        style={{ float: "right", cursor: "pointer" }}
                     />
                     <div className="add-representative-details">
                        <h1>{t("create-representative-detail-title")}</h1>
                     </div>
                     <div>
                        <div className="label-name-add-representative-details">
                           <img src={Asterisk} alt="Asterisk" />
                           <label>{t("full-name-label")}</label>
                        </div>
                        <Input
                           autoComplete="off"
                           value={values.name}
                           type="text"
                           name="name"
                           onChange={handleChange}
                           placeholder={t("name")}
                        />
                     </div>
                     <div className="error-message">{errors.name}</div>
                     <div>
                        <div className="label-name-add-representative-details">
                           <img src={Asterisk} alt="Asterisk" />
                           <label>{t("email")}</label>
                        </div>
                        <Input
                           autoComplete="off"
                           value={values.email}
                           type="email"
                           name="email"
                           onChange={handleChange}
                           placeholder={t("email")}
                        />
                     </div>
                     <div className="error-message">{errors.email}</div>
                     <div>
                        <div className="label-name-add-representative-details">
                           <img src={Asterisk} alt="Asterisk" />
                           <label>{t("phone-label")}</label>
                        </div>
                        <PhoneInput
                           international
                           defaultCountry="US"
                           value={values.phone}
                           onChange={(value) => setFieldValue("phone", value)}
                           className="custom-phone-input"
                        />
                     </div>
                     <div className="error-message">{errors.phone}</div>
                     <div>
                        <div className="label-name-add-representative-details">
                           <label>{t("location-label")}</label>
                        </div>
                        <Input
                           autoComplete="off"
                           value={values.location}
                           type="text"
                           onChange={handleChange}
                           name="location"
                           placeholder={t("location-label")}
                        />
                     </div>
                     <div className="footer-buttons-add-representative-details" key="uniqueKey">
                        <Button className="cencel-delete-button" key="cancel" onClick={onCancel}>
                           {t("cancel")}
                        </Button>
                        <Button className="delete-button" type="submit" onClick={handleSubmit}>
                           {loading ? <Spin /> : t("save-changes-button")}
                        </Button>
                     </div>
                  </div>
               </form>
            )}
         </Formik>
      </Modal>
   );
};

export default RepresentativeDetailsModal;
